import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Loads latest blocked orders with error handling
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of latest blocked orders or null if error
 */
export const loadLatestBlockedOrdersData = async (notifyError) => {
    return await apiCall(
        url.GET_LATEST_BLOCKED_ORDERS,
        'GET',
        null,
        notifyError,
        "Failed to load latest blocked orders"
    );
};